// @ts-nocheck
import useDelete from 'hooks/useDelete';
import useGet from 'hooks/useGet';
import useSave from 'hooks/useSave';
import { useToast, useWindowLocation } from 'hooks';

const useApiServices = () => {
  const toast = useToast();
  const { pathname } = useWindowLocation();

  const isOnQRFormSubmissionPage = pathname.includes('forms-qr/add-response');

  const {
    data: formData,
    fetch: fetchFormData,
    loading: loadingFormData,
  } = useGet('v1.1/custom-form/', {
    customSkipFn: ({ query }) =>
      !query?.per_page || !query?.page || isOnQRFormSubmissionPage,
  });

  const {
    data: formTemplatesForDropdown,
    fetch: fetchFormTemplatesForDropdown,
    loading: loadingFormTemplatesData,
  } = useGet('v1.1/custom-form/', {
    customSkipFn: ({ query }) => !query.per_page || !query.page,
  });

  const {
    data: formDataById,
    fetch: fetchFormDataById,
    loading: loadingFormDataById,
  } = useGet(`v1.1/custom-form/:id`, {
    customSkipFn: ({ params }) => !params.id,
    transformSuccess: ({ data }) => data?.data,
  });

  const [save] = useSave(`v1.1/custom-form/`, {
    onFailure(message) {
      toast.error(message || 'Error Performing the Action');
    },
  });
  const [updateFormData] = useSave(
    `v1.1/custom-form/:id/`,

    {
      method: 'PUT',
      onFailure(message) {
        toast.error(message || 'Error Performing the Action');
      },
    },
  );
  const [formTableDataDraft] = useSave(
    `v1.1/custom-form/move_to_draft/`,

    {
      onFailure(message) {
        toast.error(message || 'Error Performing the Action');
      },
    },
  );

  const [formTableDataRemove] = useDelete(`/v1.1/custom-form/:id`, {
    onFailure(message) {
      toast.error(message || 'Error Performing the Action');
    },
  });

  const [formResultDataRemove] = useDelete(`/v1.1/submission/:id`, {
    onFailure(message) {
      toast.error(message || 'Error Performing the Action');
    },
  });
  const [saveAttachment, { loading: attachmentLoading }] = useSave(
    'attachment/create_binary/',
    {
      method: 'POST',
    },
  );

  const { data: userList, fetch: fetchUserList } = useGet(
    '/v1.1/custom-form-dropdown/get_users/',
    {
      skip: true,
      query: { page: 1, per_page: 1000 },
    },
  );

  const {
    data: needActionOptions,
    fetch: fetchNeedActionOptions,
    loading: loadingNeedActionOptions,
  } = useGet('v1.1/submission-status/', {
    query: { page: 1, per_page: 1000 },
    customSkipFn: () => isOnQRFormSubmissionPage,
  });

  const { data: formsTagData, loading: loadingFormsTagData } = useGet(
    '/v1.1/custom-form-tag/',
    {
      query: { page: 1, per_page: 1000 },
      customSkipFn: () => isOnQRFormSubmissionPage,
      onFailure(message) {
        toast.error(message || 'Error Performing the Action');
      },
    },
  );

  return {
    serverState: {
      formData,
      loadingFormData,
      formDataById,
      loadingFormDataById,
      userList,
      needActionOptions,
      loadingNeedActionOptions,
      attachmentLoading,
      formsTagData,
      loadingFormsTagData,
      formTemplatesForDropdown,
      loadingFormTemplatesData,
    },
    apiActions: {
      fetchFormData,
      save,
      updateFormData,
      formTableDataRemove,
      formTableDataDraft,
      fetchFormDataById,
      fetchUserList,
      fetchNeedActionOptions,
      saveAttachment,
      formResultDataRemove,
      fetchFormTemplatesForDropdown,
    },
  };
};

export default useApiServices;
